import { defineStore } from 'pinia';
import Helper from '@/helpers/helper';
import ErrorHelper from '../helpers/errorManagerhelaper';
import Swal from 'sweetalert2';



export const useAgentAccountStore = defineStore('agents-accounts', {
    state: () => ({
        list: undefined,
        details: [],
        info: null
    }),
    actions: {
        setData(data) {
            this.list = data
        },

        addOne(newOne) {
            this.list ??= [];
            this.list.unshift(newOne)
        },
        updateOne(updated) {
            this.list ??= [];
            const index = this.list.findIndex(t => t.id === updated.id)
            if (index !== -1) {
                this.list[index] = updated
            }
        },
        
         removeOne(deleted) {
            this.list ??= [];
            this.list = this.list.filter(t => t.id != deleted.id) 
        },
     async  loadFromApi(londing = false) {
            try {

                if(londing){
                    Swal.showLoading();
                }
                const route = 'agents-accounts'
                const response = await fetch(Helper.route(route), Helper.requestOptionsJSON())

                if (!response.ok) {
                    const error = await ErrorHelper.handleApiError(response);
                    ErrorHelper.showError(error);
                    return;
                }
                
                const data = await response.json()
                this.list = data;

                if(londing){
                    Swal.close();
                }
                return data;
            } catch (error) {
                const normalizedError = ErrorHelper.handleUnexpectedError(error);
                ErrorHelper.showError(normalizedError);
                throw normalizedError;
            }
        }
    },
    persist: {
        storage: sessionStorage, // 👈 ici on utilise sessionStorage au lieu de localStorage
        key: `${Helper.env}__agents_accounts`
    },
})
